import _ from 'lodash'
import { ValidityDeterminate } from '@fusion-advantage/backcompat'
import { CalcRuntimeError, CalcType, DiagnosisReviewConcept, diagnosisReviewItemRequiresCarePlan, DiagnosisReviewMode, ExecutableCalc, ExecutableCalcCalculateFunction, ExecutableCalcCalculateOk, formDiagnosisReviewMode } from '@fusion-advantage/formlib'
import { selectDiagnosisReviewClinicianReviewValidation } from '../../redux/diagnosisReviewSlice'
import { createSelector } from '@reduxjs/toolkit'
import { FormRootState } from '../../redux/formStore'
import { ok, Result } from 'neverthrow'

//
//
// DIAGNOSIS REVIEW
//

export const createDiagnosisReviewValidationCalc = (getState: () => FormRootState) => {
	const selectCalculateFn = createSelector(
		(state: FormRootState) => state.diagnosisReview.models,
		selectDiagnosisReviewClinicianReviewValidation,
		(models, validation): ExecutableCalcCalculateFunction => {
			return (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
				const codeNext = ctx.getExport().Form.Encounter.CodeNext
				if(formDiagnosisReviewMode(codeNext) === DiagnosisReviewMode.Auditor) {
					// validation handled by DiagnosisAuditReviewTrigger
					return ok({ calcType: CalcType.Validation, returnValue: { determinate: ValidityDeterminate.Valid }})
				}
				// the diagnosis review concept status has updated;
				// we can check the diagnosisReview slice for the latest data
				if(_.filter(models, item => !item.status).length > 0) {
					return ok({ calcType: CalcType.Validation, returnValue: {determinate: ValidityDeterminate.Required, message: 'Status required for each diagnosis'}})
				}
				if(_.filter(models, item => diagnosisReviewItemRequiresCarePlan(item) && !item.carePlan).length > 0) {
					return ok({ calcType: CalcType.Validation, returnValue: {determinate: ValidityDeterminate.Required, message: 'Care plan required for each asserted diagnosis'}})
				}
				if(validation.queryCommentsPending > 0) {
					return ok({ calcType: CalcType.Validation, returnValue: { determinate: ValidityDeterminate.Required, message: 'Response required for all diagnosis queries' }})
				}

				return ok({ calcType: CalcType.Validation, returnValue: { determinate: ValidityDeterminate.Valid }})
			}
		}
	)
	return new ExecutableCalc({
		calcType: CalcType.Validation,
		outputCid: DiagnosisReviewConcept.cid,
		inputCids: [DiagnosisReviewConcept.cid],
		selectCalculate: () => selectCalculateFn(getState())
	})
} 
